module.exports = __webpack_public_path__ + "img/Priest-troll-m-70.580980bb.gif";